import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = {
    open: "",
    close: "",
};
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setTimes":
            return payload
        default:
            return state;
    }
}
export default reducer;